import React, { useEffect, useState } from 'react';
import { clickable } from '../../../utils/a11y';
import { useNavigate } from 'react-router-dom';
import { FaBars, FaBell, FaUserCircle, FaSignOutAlt, FaHistory, FaServer } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { getApiEndpoint } from '../../../config/api';
import CloudStaffSidebar from './CloudStaffSidebar';
import cloudsafeLogo from '../../../assets/cloudsafe-logo.png';
import AssetIDConfiguration from '../../account/Settings/AssetIDConfiguration/AssetIDConfiguration';

/**
 * CloudStaff wrapper around the shared AssetIDConfiguration tool.
 * The same component previously lived under /settings/asset-ids; it's now
 * CloudStaff-only to keep the token dictionary out of per-property settings.
 */
export default function AssetCodeDictionaryPage() {
  const navigate = useNavigate();
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [userName, setUserName] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(getApiEndpoint('/api/users/profile'), {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        if (res.ok) {
          const d = await res.json();
          setUserName(`${d.firstName || d.first_name || ''} ${d.lastName || d.last_name || ''}`.trim());
        }
      } catch { /* non-fatal */ }
    })();
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userRole');
    navigate('/login');
    toast.success('Logged out successfully');
  };

  return (
    <div className="cs-dashboard">
      <header className="cs-header">
        <div className="cs-header-left">
          <button className="cs-mobile-menu-btn" onClick={() => setMobileSidebarOpen(true)} aria-label="Open menu">
            <FaBars />
          </button>
          <img src={cloudsafeLogo} alt="CloudSafe" className="cs-logo" />
          <div className="cs-header-badge"><FaServer /><span>Cloud Staff Portal</span></div>
        </div>
        <div className="cs-header-right">
          <div className="cs-header-icons">
            <button className="cs-icon-btn" title="Notifications"><FaBell /></button>
            <div className="cs-user-avatar" aria-haspopup="menu" aria-expanded={showUserMenu}
                 {...clickable(() => setShowUserMenu(!showUserMenu), { label: 'User menu' })}>
              <FaUserCircle />
              {showUserMenu && (
                <div className="cs-user-menu">
                  <div className="cs-user-menu-header">
                    <FaUserCircle className="cs-menu-avatar" />
                    <div>
                      <p className="cs-menu-name">{userName || 'Cloud Staff'}</p>
                      <p className="cs-menu-role">Cloud Staff Admin</p>
                    </div>
                  </div>
                  <div className="cs-user-menu-divider" />
                  <button onClick={() => navigate('/cloud-staff/activity-log')} className="cs-menu-item"><FaHistory /> Activity Log</button>
                  <button onClick={handleLogout} className="cs-menu-item cs-menu-logout"><FaSignOutAlt /> Sign Out</button>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      <div className="cs-layout">
        <CloudStaffSidebar
          active="asset-code-dictionary"
          mobileOpen={mobileSidebarOpen}
          onClose={() => setMobileSidebarOpen(false)}
        />
        <main className="cs-content">
          <AssetIDConfiguration />
        </main>
      </div>
    </div>
  );
}
